let language = {
    STANDARD_ORDERS_IS_EMPTY_TIP: "您的订单是空的。",
    STANDARD_ORDERS_SEARCH_EMPTY_TIP: "没有符合条件的订单，请尝试其他搜索条件。",
    
    STANDARD_ORDERS_CANCEL_ORDER_ALERT_TITLE: "成功",
    STANDARD_ORDERS_CANCEL_ORDER_ALERT_CONTENT: "取消订单成功",
};

export { language }
